// PDParent.jsx
import React from "react";
import PDMentorDashboard from "./utils/PDMentorShared";

export const MENTOR_CONFIG = {
  userType:       "Mentor",
  memberLabel:    "Mentee",
  memberSingular: "Mentee",
  memberIcon:     "👧",
  headerIcon:     "👨‍👧",
  headerTitle:    "Teacher/Mentor/Caoch Engagement",
  headerSub:      "Guide your metee's 12-week streak journey",
  accentColor:    "pink",
  targetType:     "Mentee",
};

export default function PDParent(t, role, currentTheme) {
  return <PDMentorDashboard config={MENTOR_CONFIG} role={role} />;
}